module.exports = __webpack_public_path__ + "static/media/Avatars_Other-10.99500b54.png";